import React, { useEffect, useState } from 'react';
import LoginPageNotifier from "./LoginPageNotifier";
import { UserInitiatedLogoutMessage } from "../../constants/textConstants";

const LogoutMessageNotifier = ({
    logoutMessage
}) => {

    return (
        (logoutMessage &&
            <LoginPageNotifier
                colorStyle={(logoutMessage === UserInitiatedLogoutMessage
                    ? "success"
                    : "error")}               
            >
                {logoutMessage}
            </LoginPageNotifier>
        )
    );
};

export default LogoutMessageNotifier;